import { environment } from '@/shared/enviroment/environment';
import { ApiService } from '@/shared/service/Apiservice';
import { ConstructionProductsResponseDto } from '../dto/construction-products.dto';
import axios from 'axios';

class ConstructionProductsService {
  private apiRootServer = environment.api.apiRootServer;
  private __Apiservice: ApiService;

  constructor() {
    const axiosInstance = axios.create();
    this.__Apiservice = new ApiService(axiosInstance, this.apiRootServer);
  }

  async getProductsByCategory(categorySlug: string): Promise<ConstructionProductsResponseDto> {
    return this.__Apiservice.getRequest(`products/category/${categorySlug}`, {}, {
      apiRoot: this.apiRootServer,
    });
  }

  async getProductsByCategoryName(categoryName: string): Promise<ConstructionProductsResponseDto> {
    // Convert category name to slug format (lowercase, spaces and ampersands to hyphens)
    const categorySlug = categoryName
      .toLowerCase()
      .replace(/\s*&\s*/g, '-') // replace ampersands (with optional spaces) with hyphen
      .replace(/\s+/g, '-')      // replace spaces with hyphen
      .replace(/-+/g, '-')        // collapse multiple hyphens
      .replace(/^-+|-+$/g, '');   // trim leading/trailing hyphens
    return this.getProductsByCategory(categorySlug);
  }

  async searchProductsByCategory(categoryName: string, searchTerm?: string): Promise<ConstructionProductsResponseDto> {
    const params: any = {};
    if (searchTerm) {
      params.search = searchTerm;
    }
    
    const categorySlug = categoryName.toLowerCase().replace(/\s+/g, '-');
    return this.__Apiservice.getRequest(`products/category/${categorySlug}`, params, {
      apiRoot: this.apiRootServer,
    });
  }

  async getAllConstructionProducts(): Promise<ConstructionProductsResponseDto> {
    return this.__Apiservice.getRequest('products', {}, {
      apiRoot: this.apiRootServer,
    });
  }
}

// Create a singleton instance
const constructionProductsService = new ConstructionProductsService();
export default constructionProductsService;